import { CSSProperties } from "react";
import { Form } from "antd";
import styled from "styled-components";

const { Item } = Form;

export const FormItem = styled(Item)`
  margin-top: 15px;
  .ant-input {
    margin-left: 0;
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@normal-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]};
    }
  }

  .ant-form-item-label {
    text-align: start;
    min-width: 100%;
    max-width: 100%;
    padding: 3px 0;
    z-index: 1;
  }

  .ant-form-item-label > label {
    font-family: ${(props) => props.theme["@font-family"]};
    font-weight: ${(props) => props.theme["@normal-font-weight"]};
    font-size: ${(props) => props.theme["@medium-font-size"]};
    pointer-events: none !important;
  }

  .ant-col.ant-form-item-label > label.ant-form-item-required:hover {
    pointer-events: none !important;
  }
  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]};
    height: ${(props) => props.theme["@height-input-lg"]};
    &:hover,
    &:focus {
      border-color: ${(props) => props.theme["@primary-color-brand"]} !important;
    }
  }
  .ant-form-item-required::before {
    content: "" !important;
  }

  .ant-form-item-control-input-content > textarea {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]};
    &:hover {
      border-color: ${(props) => props.theme["@primary-color-brand"]} !important;
      background-color: ${(props) => props.theme["@hover-input-wrapper"]};
    }
  }

  .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector,
  .ant-input[disabled] {
    background: ${(props) => props.theme["@input-background-disabled"]};
    color: ${(props) => props.theme["@profile-text-color"]};
    cursor: default;
    :hover {
      border: 1.6px solid ${(props) => props.theme["@input-border-color"]};
    }
  }

  .ant-input-affix-wrapper-disabled,
  .ant-input-disabled {
    :hover {
      border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
      background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
      cursor: default;
      > input {
        background-color: ${(props) => props.theme["@input-background-disabled"]} !important;
        border: none !important;
      }
    }
  }

  .ant-form-item-control-input-content > .ant-input.ant-input-status-error {
    border: 1.6px solid ${(props) => props.theme["@danger-color"]} !important;
    background-color: ${(props) => props.theme["@danger-background"]};
    :hover {
      border-color: ${(props) => props.theme["@danger-color"]};
      background-color: ${(props) => props.theme["@danger-background"]} !important;
    }
  }

  .ant-select-disabled.ant-select:not(.ant-select-customize-input) .ant-select-selector:hover {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
  }

  .ant-form-item-control-input-content > textarea:hover:disabled {
    border: 1.6px solid ${(props) => props.theme["@input-border-color"]} !important;
  }
`;

export const ProcessesFormItem: CSSProperties = {
  width: "100%",
};
